"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferChunkedAssetResponseToJSON = exports.TransferChunkedAssetResponseFromJSONTyped = exports.TransferChunkedAssetResponseFromJSON = exports.instanceOfTransferChunkedAssetResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TransferChunkedAssetResponse interface.
 */
function instanceOfTransferChunkedAssetResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTransferChunkedAssetResponse = instanceOfTransferChunkedAssetResponse;
function TransferChunkedAssetResponseFromJSON(json) {
    return TransferChunkedAssetResponseFromJSONTyped(json, false);
}
exports.TransferChunkedAssetResponseFromJSON = TransferChunkedAssetResponseFromJSON;
function TransferChunkedAssetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
    };
}
exports.TransferChunkedAssetResponseFromJSONTyped = TransferChunkedAssetResponseFromJSONTyped;
function TransferChunkedAssetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
    };
}
exports.TransferChunkedAssetResponseToJSON = TransferChunkedAssetResponseToJSON;
